import React from 'react';
import notFoundImage from '../assets/images/jajasemen.png';


interface TeAmoPageProps {
  isDark: boolean;
}

const TeAmoPage: React.FC<TeAmoPageProps> = ({ isDark }) => {
  return (
    <div className="min-h-screen pt-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className={`text-5xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Going somewhere forbidden?
        </h1>
        <p className={isDark ? 'text-gray-300' : 'text-gray-600'}>
          Nothing to see here...

          <img src={notFoundImage} alt="jaja semen" className="w-64 h-64 mx-auto mb-8 object-contain"
        />
        </p>
      </div>
    </div>
  );
};

export default TeAmoPage;